import React,{useState, useEffect} from 'react';
import ePlusIcon from '../../../assets/img/event-imgs/e-plus.svg'
import {blogPosts as blogPostApi} from '../../../api';
import { Link } from 'react-router-dom';
const BlogPosts = () => {
    const [ blogPosts, setBlogPosts ] = useState([])
    useEffect(()=>{
        blogPostApi().then(( data) =>{
            setBlogPosts(data)
        })
    },[])
    console.log("try to Fatch data fake Database",blogPosts)
 
    return (
       <div className="row gy-4">
           {
               blogPosts.map(( item, index ) => <div  key={index}  className="col-12 col-md-6 col-xxl-4">
                    <Link className="card linking-design" style={{backgroundColor: "#171717", borderRadius: "20px", borderStyle: "none"}} to={`/blog/details/${index}`}>
                        <div className="position-relative">
                            <button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor: "#00000041", borderStyle: "none", right: "4%", bottom: "4%"}}>
                                <img src={ePlusIcon} alt='' />
                            </button>
                            <img className="w-100" src={item.blogThumbnail} style={{borderRadius: "20px 20px 0px 0px"}} alt='' />
                        </div>
                        <div className="w-100" style={{height: "4px", background: "linear-gradient(90deg, #B402F6, #40EEFE)"}}></div>
                        <div className="card-body">
                            <div className="row gap-2">
                                <div className="col-12">
                                    <span className="b_dt">{item.blogDate}</span>
                                </div>
                                <div className="col-12">
                                    <img className="me-1" src={item.authorImage} alt='' />
                                    <span className="txt_name">{item.authorName}</span>
                                </div>
                                <div className="col-12">
                                    <span className="txt_wa">{item.blogDesc}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
               </div>)
           }
          
        </div> 
    );
};

export default BlogPosts;